import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const NumberPhone = () => {
    return (
        <div id="number-phone-log-in-page">
            <div className="title-log-in xpr-2 xpl-2 xmb-6">
                <span>ورود به سایمان دیجیتال</span>
            </div>
            <div className="description xpx-2 xmb-6">
                <p>برای ورود یا ثبت‌نام لطفا شماره‌ موبایل خود را وارد کنید.</p>
            </div>
            <form id="form-phone-code-login">
                <div className="input-log-in position-relative xmb-6">
                    <input
                        type="number" maxLength="11" placeholder="شماره موبایل شما"
                        className="form-control input-phone-number input-normal" id="get-phone-number-input"/>
                    <div className="text-error-phone xmt-2 xmr-6" id="text-error-phone">
                        شماره وارد شده نا معتبر می باشد
                    </div>
                    <div className="phone-icon position-absolute">
                        <IconName name="phone" className="icon"/>
                    </div>
                    <div className="error-icon position-absolute" id="error-icon-phone-number">
                        <IconName name="info" className="icon"/>
                    </div>
                </div>
                <div className="button-log-in xmb-6">
                    <button type="submit">ادامه</button>
                </div>
                </form>
                    <div className="dark-mode-button xpt-6 xpb-2 d-flex justify-content-between align-items-center">
                        <div className="dark-text">
                            <span><IconName name="darkmode" className='icon'/></span>
                            <span className="text xmr-1">حالت تاریک</span>
                        </div>
                        <div className="switch-button">
                            <div className="form-check form-switch">
                                <input className="form-check-input dark-mode-switch" type="checkbox" role="switch"/>
                            </div>
                        </div>
                    </div>
        </div>
);
};

export default NumberPhone;
